export const setEvents = events => ({ type: 'SET_TEMPLATE_EVENTS', events })
export const setFormClean = () => ({ type: 'SET_FORM_CLEAN' })
export const setDays = days => ({ type: 'SET_MULTI_TEMPLATE_DAYS', days })
export const setRequiredPositions = requiredPositions => ({ type: 'SET_TEMPLATE_REQUIRED_POSITIONS', requiredPositions })
export const addEvents = events => ({ type: 'ADD_TEMPLATE_EVENTS', events })
export const removeEvents = events => ({ type: 'REMOVE_TEMPLATE_EVENTS', events })
export const updateEvents = events => ({ type: 'UPDATE_TEMPLATE_EVENTS', events })
export const setSelectedCount = count => ({ type: 'SET_TEMPLATE_EVENTS_SELECTED_COUNT', count })
